import React, { useEffect } from 'react';
import axios from 'axios';
import Header from './Header';
import Footer from './Footer';
import './LogoutPage.css';

const LogoutPage = () => {
  // Destroy server session when logout page is visited
  useEffect(() => {
    axios.post('/auth/logout', {}, { withCredentials: true }).catch(() => {});
  }, []);

  const handleLogin = () => {
    // Redirect to SSO login
    window.location.href = '/auth/login';
  };

  return (
    <div className="logout-page">
      <Header user={null} />
     
      
      <main className="logout-content">
        <div className="logout-illustration-container">
          <img src="/images/illustration-complete.png" alt="Language learning illustration" className="logout-illustration-image" />
        </div>

        <div className="logout-content-section">
          <p className="logout-subtitle">Learning & Talent Transformation</p>
          <h1 className="logout-title">
            Welcome to Language Buddy your trusted partner in mastering foreign languages.
          </h1>
          
          <p className="logout-description">
            Your session has ended. Please log in again to continue learning.
          </p>

          <button className="logout-login-btn" onClick={handleLogin}>
            Login
            <img src="/images/arrow-right.svg" alt="" className="arrow-icon" />
          </button>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default LogoutPage;
